import React, { useEffect, useState } from "react";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";
import { swalWarningMessage } from "../../../../Constant/swalMessage";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  editAgentAction,
  editDataReducerActiom,
  getAgentAction,
  getAgentVersionAction,
  getDemoBotDataAction,
  saveAgentAction,
  updateDemoBotAction,
} from "../../ProjectSection/Agents/Store/Agent.action";
import { checkPromptAction } from "../../ProjectSection/CampaignSection/Store/Campaign.action";
import { getCustomWriteAccess, isEmpty } from "../../CommonComponents/Common";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import AgentSelect from "./AgentType";
import DebouncedInput from "../../../../common/components/DebouncedTextfield";

const extractAid = (urlString: string) => {
  try {
    const url = new URL(urlString, window.location.origin);
    return url.searchParams.get("aid");
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
};

const Agent = ({ agentTypes, agentStep, show, onClose, setSuccessState }) => {
  const dispatch = useDispatch();
  const { projectId } = useParams<{ projectId: string }>();

  const reducer: any = useSelector((state) => state);
  const {
    AgentReducer: { editAgentData },
    AccountReducer: { selectedAccount },
  } = reducer;

  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [agent, setAgent] = useState({
    agentName: "",
    organisationName: "",
    greetingMessage: "",
    secondMessage: "",
    voicemailMessage: "",
    inboundGreetingMessage: "",
    context: "",
    rules: "",
    conversationData: [{ input: "Hi", output: "" }],
    objections: [],
    projectId,
    agentType: agentTypes[agentStep] || "call",
    demoBotUrl: "",
  }) as any;
  const {
    agentName,
    organisationName,
    greetingMessage,
    context,
    rules,
    agentType,
    demoBotUrl,
  } = agent;
  const [demoBot, setDemoBot] = useState() as any;
  const [versionList, setVersionList] = useState<any>([]);
  const [versionLoad, setVersionLoad] = useState(false);

  useEffect(() => {
    if (selectedAccount?.params?.multiAgent) setCurrentStep(0);
  }, [selectedAccount]);

  useEffect(() => {
    if (!isEmpty(editAgentData)) {
      setAgent({ ...editAgentData, projectId, agentType });
      setCurrentStep(1);
    }
    return () => {
      dispatch(editDataReducerActiom({}));
    };
  }, [editAgentData]);

  useEffect(() => {
    const fetchVersions = async () => {
      if (!agent?._id) return;
      setVersionLoad(true);
      const params = {
        agentId: agent?._id,
        pageIndex: 1,
        pageSize: 50,
      };
      const versionListRes: any = await dispatch(getAgentVersionAction(params));
      if (versionListRes?.status === 200) {
        const sortedVersions = versionListRes?.data?.sort(
          (a, b) => Number(b?.version) - Number(a?.version)
        );
        setVersionList(sortedVersions);
      }
      setVersionLoad(false);
    };

    fetchVersions();
  }, [agent?._id]);

  useEffect(() => {
    const init = async () => {
      const obj = {
        demobotDataId: extractAid(demoBotUrl),
        countData: true,
      };
      const res: any = await dispatch(getDemoBotDataAction(obj));
      setDemoBot(res);
    };
    if (demoBotUrl) init();
  }, [demoBotUrl]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "context") {
      let replacedString = value.replace(
        /\{\{OrganizationName\}\}/g,
        organisationName
      );

      replacedString = replacedString.replace(/\{\{AgentName\}\}/g, agentName);
      value = replacedString;
    }

    setAgent((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    if (!checkValidation()) {
      return;
    }
    if (agentType === "call") {
      if (currentStep === 1) {
        if (!context?.trim() || !rules?.trim()) {
          swalWarningMessage("Please proceed to the next step");
          return false;
        }
      }
      if (currentStep === 2 && !rules.trim()) {
        swalWarningMessage("Please proceed to the next step");
        return false;
      }
    }

    if (agentType === "call" || (currentStep === 1 && agentType !== "call")) {
      setLoading(true);
      const isEditing = !isEmpty(editAgentData);

      const agentPayload = {
        ...agent,
      };

      const isUnchanged =
        [
          "agentName",
          "organisationName",
          "greetingMessage",
          "secondMessage",
          "context",
          "rules",
          "voicemailMessage",
        ].every((key) => editAgentData?.[key] === agent?.[key]) &&
        (selectedAccount?.params?.inboundEnable
          ? editAgentData?.inboundGreetingMessage ===
            agent?.inboundGreetingMessage
          : true);

      let nextVersion;

      if (versionList?.length) {
        const maxVersion = versionList[0]?.version;
        nextVersion = (Number(maxVersion) + 1).toString();
      } else if (editAgentData?.currentVersion) {
        nextVersion = (Number(editAgentData?.currentVersion) + 1).toString();
      } else {
        nextVersion = "1";
      }

      if (isUnchanged) {
        agentPayload["create"] = false;
      } else {
        agentPayload["version"] = nextVersion;
        agentPayload["changeLog"] = new Date().toISOString();
        agentPayload["create"] = true;
      }

      if (isEditing) {
        if (!editAgentData?.currentVersion) {
          const defaultAgentPayload = {
            ...editAgentData,
            version: "1",
            changeLog: new Date().toISOString(),
            projectId,
          };
          const versionSec = {
            ...agent,
            version: "2",
            changeLog: new Date().toISOString(),
          };

          await dispatch(
            editAgentAction(editAgentData?._id, defaultAgentPayload, false)
          );
          await dispatch(
            editAgentAction(editAgentData?._id, versionSec, false)
          );
        } else if (editAgentData?.currentVersion === "1") {
          if (versionList?.length < 1) {
            const defaultAgentPayload = {
              ...editAgentData,
              version: "1",
              changeLog: new Date().toISOString(),
              projectId,
              create: true,
            };
            await dispatch(
              editAgentAction(editAgentData?._id, defaultAgentPayload, false)
            );
          }
        }
      }

      const res: any =
        isEditing && editAgentData?.currentVersion
          ? await dispatch(
              editAgentAction(editAgentData?._id, agentPayload, false)
            )
          : await dispatch(saveAgentAction({ ...agent, version: "1" }));

      if (res?.status === 200) {
        onClose();
        setSuccessState((prev) => ({
          ...prev,
          successPopup: true,
          successPopupHeading: isEditing ? "Update Agent" : "Add Agent",
          successPopupMessage: isEditing
            ? " Agent updated successfully"
            : "Agent added successfully",
        }));
        await dispatch(getAgentAction(projectId));
        if (isEditing && demoBot) {
          const customParameters = await getcustomParameters();
          const obj = {
            ...demoBot,
            customParameters: customParameters,
          };
          const demoBotParam = {
            demobotDataId: demoBot?._id,
          };
          await dispatch(updateDemoBotAction(obj, demoBotParam));
        }
      }
      setLoading(false);
    }
  };

  const getcustomParameters = async () => {
    const { conversationData, voicemailMessage } = agent;
    const promptObj = {
      examples: conversationData,
      agent_name: agentName,
      organization_name: organisationName,
      greeting_message: greetingMessage,
      second_message: agent.secondMessage,
      context,
      rules,
      voice_mail_message: voicemailMessage,
    };

    const manualKeys: any = await dispatch(checkPromptAction(promptObj));
    return manualKeys?.fields || [];
  };

  const handlePreviousStep = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };
  const handleNext = () => {
    if (currentStep !== 0 && !checkValidation()) {
      return;
    }
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const checkValidation = () => {
    if (currentStep === 1) {
      if (!agentName.trim()) {
        swalWarningMessage("Agent name is required");
        return false;
      }
      if (agentName?.trim()?.length > 50) {
        swalWarningMessage("Agent name should not exceed 50 characters");
        return false;
      }
      if (!organisationName.trim()) {
        swalWarningMessage("Organisation name is required");
        return false;
      }
      if (organisationName?.trim()?.length > 400) {
        swalWarningMessage(
          "Organisation name should not exceed 400 characters"
        );
        return false;
      }

      if (agentType === "call") {
        if (!greetingMessage.trim()) {
          swalWarningMessage("Greeting message is required");
          return false;
        }
      } else {
        if (!context.trim()) {
          swalWarningMessage("Context is required");
          return false;
        }
      }

      // if (agentType === "call") {
      //   if (
      //     selectedAccount?.params?.inboundEnable &&
      //     !inboundGreetingMessage.trim()
      //   ) {
      //     swalWarningMessage("Inbound greeting message required");
      //     return false;
      //   }
      // }
    }
    if (currentStep === 2 && !context.trim()) {
      swalWarningMessage("Context is required");
      return false;
    }
    if (currentStep === 3 && !rules.trim()) {
      swalWarningMessage("'Rules' is a required field");
      return false;
    }

    return true;
  };

  function openNav(id) {
    const myNav = document.getElementById(`myNav${id}`) as HTMLElement;
    if (myNav) {
      myNav.classList.add("active");
    }
  }

  function closeNav(id) {
    const myNav = document.getElementById(`myNav${id}`) as HTMLElement;
    if (myNav) {
      myNav.classList.remove("active");
    }
  }

  const openBigTextArea = (closeNav, name, value, id) => {
    return (
      <div id={`myNav${id}`} className="overlay1">
        <a href="javascript:void(0)" className="closebtn" onClick={closeNav}>
          &times;
        </a>
        <div className="overlay-content1">
          <DebouncedInput
            initialValue={agent?.[name]}
            onDebouncedUpdate={(val) =>
              setAgent((prev) => ({
                ...prev,
                [name]: val,
              }))
            }
            className="text-area"
          />
        </div>
      </div>
    );
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <AgentSelect agent={agent} handleChange={handleChange} />;
      case 1:
        return (
          <FirstStep
            agent={agent}
            handleChange={handleChange}
            selectedAccount={selectedAccount}
            setAgent={setAgent}
          />
        );
      case 2:
        return (
          <SecondStep
            agent={agent}
            openNav={openNav}
            closeNav={closeNav}
            openBigTextArea={openBigTextArea}
            setAgent={setAgent}
          />
        );
      case 3:
        return (
          <ThirdStep
            agent={agent}
            openNav={openNav}
            closeNav={closeNav}
            openBigTextArea={openBigTextArea}
            setAgent={setAgent}
          />
        );
      default:
        return null;
    }
  };

  const showPrevious = () => {
    if (
      selectedAccount?.params?.multiAgent &&
      !agent?.updatedAt &&
      currentStep > 0
    ) {
      return true;
    }
    if (!selectedAccount?.params?.multiAgent && currentStep > 1) {
      return true;
    }
    if (!isEmpty(editAgentData) && currentStep > 1) {
      return true;
    }

    return false;
  };
  return (
    <CommonModal
      show={show}
      toggle={onClose}
      heading={`${
        isEmpty(editAgentData) ? "Create a new Agent" : "Edit Agent"
      }`}
      body={renderStep()}
      size={750}
      spin={loading}
      handlePrevious={handlePreviousStep}
      handleSave={handleSave}
      saveButtonText={"Save"}
      handleNext={handleNext}
      showNextButton={true}
      nextButtonText={"Next"}
      showPreviousButton={showPrevious()}
      disableNextButton={
        currentStep === 3 || (agentType !== "call" && currentStep !== 0)
      }
      disableSaveButton={currentStep === 0 || versionLoad}
      showSaveButton={getCustomWriteAccess(reducer) === "write"}
    />
  );
};

export default Agent;
